import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ConditionsResourceIdentifier, InterviewDisclosureIdentifier, ScreensQuestionResource } from '@Components/mras/core';
import { SharedModule } from '@Shared/shared.module';

@Component({
    selector: 'jhi-reflexive-picklist-input',
    templateUrl: './reflexive-picklist-input.component.html',
    imports: [SharedModule]
})
export class ReflexivePicklistInputComponent implements OnInit, OnChanges {
    @Input() question: ScreensQuestionResource;
    @Input()
        value: string[];
    @Output()
        valueChange = new EventEmitter<string[]>();

    @Input()
        summaryMode: boolean;

    @Input()
        name: string;
    @Input()
        options: string[];
    @Output()
        action = new EventEmitter();

    @Input()
        searchEnabled: boolean;
    @Input()
        searchText: string;
    @Input()
        category: string;

    @Input()
        disclosureIdentifier: InterviewDisclosureIdentifier;

    searchIdentifier: ConditionsResourceIdentifier;

    searchedDisclosures: string[] = [];

    checkboxValue: string[] = [];

    @Input()
        showNoneOfTheAbove: boolean;
    @Input()
        triggeredDisclosures: string[];
    noneOfTheAbove: boolean;

    constructor() {}

    ngOnInit(): void {
        this.searchIdentifier = new ConditionsResourceIdentifier();
        this.searchIdentifier.caseId = this.disclosureIdentifier.caseId;
        this.searchIdentifier.interviewCode = this.disclosureIdentifier.interviewCode;
        this.searchIdentifier.interviewInstance = this.disclosureIdentifier.interviewInstance;
        this.searchIdentifier.lifeInstance = this.disclosureIdentifier.lifeInstance;
        this.searchIdentifier.categoryCode = this.category;
        this.searchIdentifier.limit = 100;

        this.options.forEach(e => {
            this.checkboxValue[e] = false;
        });
        if (this.value?.length > 0) {
            this.value
                .filter(e => this.options.includes(e))
                .forEach(e => {
                    this.checkboxValue[e] = true;
                });
            this.value
                .filter(e => !this.options.includes(e))
                .forEach(e => {
                    this.searchedDisclosures.push(e);
                });
        }

        this.noneOfTheAbove = this.value?.length === 0;
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.options.forEach(e => {
            this.checkboxValue[e] = false;
        });
        this.value?.forEach(e => {
            this.checkboxValue[e] = true;
        });
        this.noneOfTheAbove = this.value?.length === 0;
    }

    onClick(name: string) {
        if (this.value == null) {
            this.value = [];
        }
        if (this.value.includes(name)) {
            this.value.splice(this.value.indexOf(name), 1);
        } else {
            this.value.push(name);
        }
        if (this.value.length === 0) {
            this.value = null;
        }

        if (this.question.invalid) {
            this.question.invalid = false;
        }

        this.valueChange.emit(this.value);
        this.action.emit({
            name,
            value: this.value
        });
    }

    handleDisclosureSearchEvent(disclosureName: string) {
        this.onClick(disclosureName);
    }

    onNoneClick(checked: boolean) {
        this.noneOfTheAbove = checked;
        this.value = checked ? [] : null;
        this.valueChange.emit(this.value);
        this.action.emit(null);
    }
}
